import React from 'react';
import { Link } from 'react-router-dom';

const CatCard = ({ cat, onDelete }) => {
  return (
    <div className="cat-card">
      <img 
        src={cat.photo || 'https://api.images.cat/300/300/03276630-740c-47dc-8f85-82ca3aa82289'} 
        alt={cat.name}
        className="cat-photo"
      />
      <div className="cat-card-content">
        <h3>{cat.name}</h3>
        <p><strong>Age:</strong> {cat.age} years</p>
        <p><strong>Breed:</strong> {cat.breed}</p>
        <p><strong>Color:</strong> {cat.color}</p>
        <div className="cat-card-actions">
          <Link to={`/cat/${cat.id}`} className="btn btn-view">
            View Details
          </Link>
          <Link to={`/edit/${cat.id}`} className="btn btn-edit">
            Edit
          </Link>
          <button 
            onClick={() => onDelete(cat.id)} 
            className="btn btn-delete"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default CatCard;
